export default __webpack_public_path__ + "static/media/nl.9d4a525f.svg";